import Enumerator from '../global/Enumerator';

export const ticketOpenBankingTypes = ['none', 'basiq'];

export class TicketOpenBankingType extends Enumerator {
  static default() {
    return this.of('none');
  }
}
TicketOpenBankingType.initEnum(ticketOpenBankingTypes);

export default {
  ticketOpenBankingTypes,
  TicketOpenBankingType
};
